import React from 'react';

import { colors } from 'reactApp/colors';
import { IconProps } from 'reactComponents/icons/utilities/iconUtils';

type Props = IconProps & React.SVGProps<SVGSVGElement>;
export const IconSearch = ({
    width = '16',
    height = '16',
    className,
    ...rest
}: Props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 16 16"
        className={className}
        {...rest}
    >
        <path
            fill={colors.activityGrey}
            fillRule="evenodd"
            d="M10.91 12.806A6.964 6.964 0 017 14c-3.863 0-7-3.137-7-7s3.137-7 7-7 7 3.137 7 7a6.97 6.97 0 01-1.18 3.889l2.114 2.113a1.354 1.354 0 01-1.914 1.914l-2.11-2.11zM7 2.477A4.524 4.524 0 0111.523 7 4.524 4.524 0 017 11.523 4.524 4.524 0 012.477 7 4.524 4.524 0 017 2.477z"
        />
    </svg>
);

export default IconSearch;
